import { FC, ReactNode } from 'react'

import { Tooltip } from '@mantine/core'

interface HintTooltipProps {
  label: string
  children: ReactNode
  disabled?: boolean
}

export const HintTooltip: FC<HintTooltipProps> = ({
  label,
  children,
  disabled,
}) => (
  <Tooltip
    label={label}
    multiline
    w={300}
    withArrow
    openDelay={300}
    disabled={disabled}
  >
    <div>{children}</div>
  </Tooltip>
)
